<div class="shell" [style.--agent-dock-offset]="desktopDockOffset()">
  <div class="application"><ng-content></ng-content></div>
  @if (available()) {
    @if (ui.open()) {
      <aside class="dock" aria-label="TWINSIGHT Agent" [style.width.px]="effectiveWidth()"
             [cdkTrapFocus]="compact()" [cdkTrapFocusAutoCapture]="true">
        <div class="resize-handle" role="separator" tabindex="0" aria-label="Resize agent panel"
             aria-orientation="vertical" [attr.aria-valuemin]="minimumWidth"
             [attr.aria-valuemax]="maximumWidth()" [attr.aria-valuenow]="effectiveWidth()"
             (pointerdown)="startResize($event)" (pointermove)="resize($event)"
             (pointerup)="endResize($event)" (pointercancel)="endResize($event)"
             (lostpointercapture)="endResize($event)" (keydown)="resizeWithKeyboard($event)"></div>
        <header>
          <div class="agent-title"><span class="material-symbols-outlined" aria-hidden="true">auto_awesome</span><h2>Agent</h2></div>
          <button mat-icon-button aria-label="Close agent panel" (click)="ui.close()" cdkFocusInitial>
            <span class="material-symbols-outlined" aria-hidden="true">close</span>
          </button>
        </header>
        <div class="agent-content"><ng-content select="[agent-content]"></ng-content></div>
      </aside>
    } @else {
      <button mat-fab class="agent-bubble" aria-label="Open TWINSIGHT Agent" (click)="ui.toggle()">
        <span class="material-symbols-outlined" aria-hidden="true">auto_awesome</span>
      </button>
    }
  }
</div>
